import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RewardGifState {
  visible: boolean;
  isReward: boolean;
  coins: number;
}
export interface ShowPointState {
  visible: boolean;
  points: number;
}
export interface EncouragementState {
  enabled: boolean;
  currentMessage: string | null;
  messageType: 'praise' | 'encourage' | 'celebrate' | 'welcome_back' | 'greeting';
  visible: boolean;
}

export interface CommonState {
  loading: boolean;
  ui: {
    dialog: {
      [name: string]: boolean;
    };
    dialogState: any;
  };
  rewardGif: RewardGifState;
  showPoint: ShowPointState;
  encouragement: EncouragementState;
}

const initialState: CommonState = {
  loading: false,
  ui: { dialog: {}, dialogState: undefined },
  rewardGif: {
    visible: false,
    isReward: false,
    coins: 0,
  },
  showPoint: {
    visible: false,
    points: 0,
  },
  encouragement: {
    enabled: true,
    currentMessage: null,
    messageType: 'greeting',
    visible: false,
  },
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    toggleModals: (state, action: PayloadAction<string>) => {
      state.ui.dialog = {
        ...state.ui.dialog,
        [action.payload]: !state.ui.dialog[action.payload],
      };
    },
    closeModals: (state, action: PayloadAction<string>) => {
      state.ui.dialog = { ...state.ui.dialog, [action.payload]: false };
    },
    setRewardGif: (state, action: PayloadAction<Partial<RewardGifState>>) => {
      state.rewardGif = {
        ...state.rewardGif,
        ...action.payload,
      };
    },
    setShowPoint: (state, action: PayloadAction<Partial<ShowPointState>>) => {
      state.showPoint = {
        ...state.showPoint,
        ...action.payload,
      };
    },
    setEncouragement: (state, action: PayloadAction<Partial<EncouragementState>>) => {
      state.encouragement = {
        ...state.encouragement,
        ...action.payload,
      };
    },
  },
});

export const { setLoading, toggleModals, closeModals, setRewardGif, setShowPoint, setEncouragement } = commonSlice.actions;

export default commonSlice.reducer;
